import React, { Fragment } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { FormattedMessage } from 'react-intl';

const GraceThankYou = ({styles}) => (
    <div className="thank-you thank-you-grace">{``}
        <div className="mainDesktop__container">
            <div>
                <img className="grace-logo" src="https://s3.eu-west-2.amazonaws.com/assets.aflete.com/checkout/grace-logo.png" alt=""/>
            </div>
            <hr />
            <div><h1>Thank you!</h1></div>
            <br />
            <p><strong>Your payment has been processed successfully</strong>
                <img className="check-box-small" src="https://s3.eu-west-2.amazonaws.com/assets.aflete.com/checkout/checkbox.png" alt=""/>
            </p>
            <br />
            <h3>Guides</h3>
            <p>
                You will receive an order confirmation email with all the details and download links for any Guide’s included in your order.
            </p>
            <p>
                Please, check your spam or junk folders if it's not in your inbox.
            </p>
            <br />
            <h3>Physical Products</h3>
            <p>You will receive an email confirming your order and showing you exactly what you have purchased.</p>
            <p>All orders are final and cannot be changed. </p>
            <br />
            <h3>Shipping</h3>
            <p>All shipping information is on our shipping page.</p>
            <a href="https://gracefitguide.com/shipping-info/" target="_blank">
                <RaisedButton
                    type="submit"
                    label="Shipping Info"
                    style={styles.button}
                    primary
                />
            </a>
            <br />
            <br />
            <h3>Support</h3>
            <p>For any problems please contact our support</p>
            <a href="https://gracefitguide.com/faq" target="_blank">
                <RaisedButton
                    type="submit"
                    label="FAQ"
                    style={styles.button}
                    primary
                />
            </a>
            <br />
            <br />
        </div>
    </div>   
);

export default GraceThankYou;